import AppHeader from './component'

export default AppHeader
